import { useMutation } from 'react-query'
import { request } from '../request'

export const useCreateUser = () => {
  return useMutation((data: Record<string, string | number | undefined>) =>
    request({
      url: '/auth/user',
      method: 'POST',
      data: data,
    }),
  )
}
